import React, { ReactElement } from 'react';
import * as app from "../services/AppService";

interface IAccordionItemProps {
    children: ReactElement | ReactElement[] | any;
    title: string;
    disabled?: boolean;
    show?: boolean;
    class?: string;
    parentId?: string;
}

function AccordionItem({ children, title, disabled, show, parentId }: IAccordionItemProps) {
    return (

<div className="accordion-item ">
            <h2 className="accordion-header " id="headingOne">
                <button style={{ "height": "35px" }} className={`accordion-button color-danger fw-bold ${disabled ? "opacity-50" : ""}`}
                    type="button" data-bs-toggle="collapse" data-bs-target={`#${title}`} aria-expanded={show ? "true" : "false"} aria-controls={title} disabled={disabled}>
            {app.translate(title)}
        </button>
    </h2>
            <div id={title} className={`accordion-collapse collapse ${show ? "show" : ""}`} aria-labelledby="headingOne" data-bs-parent={parentId ? `#${parentId}` : undefined}>
        <div className="accordion-body">
            {children}
        </div>
    </div>
</div>

    );
}

AccordionItem.defaultProps = {
    class: " ",
    disabled: false,
    show: false
}
export default AccordionItem;